import update from 'immutability-helper';
import { uuid } from 'src/shared/helpers';

import config from 'src/shared/config';
import { Side } from '../side';
import { DEFAULT_AREA_SIZE, ModelArea, resizeArea } from './modelArea';

/**
 * Model side interface
 * @param sideID The side ID
 * @param name The side name
 * @param imageID The image ID
 * @param imageUrl the image url used for preview
 * @param ppcm ppcm used to calculate physical size
 * @param code the side code
 * @param areas the side areas
 * @param tempImageFileKey a temp file object key used for the image
 * @param guid a temp guid used during the configuration, just use uuid() as value
 * @param originalSideGuid the original side guid
 * @param sortOrder order position
 */
export interface ModelSide {
    sideID: number | null;
    imageID: number | null;
    imageUrl: string;
    ppcm: number;
    code: string;
    tempImageFileKey: string;
    areas: ModelArea[];
    originalSideGuid: string;
    guid: string;
    sortOrder: number;
    mandatory: boolean;
    canRotate: boolean;
    cameraLocationID: string | null;
}

export const defaultModelSideImageUrl = config.isProduction
    ? 'https://zakekemediacdn.blob.core.windows.net/cdn/images/modelSideDefaultImage/k27yw35nt48zj69.png'
    : 'https://cdn-testing.zakeke.com/files/temp/2020/10/01/66d218a9315640db900de6f89be8c610/k27yw35nt48zj69.png';

// Sample side when adding a new side
export const createDefaultModelSide = (side: Side) => {
    const modelSide: ModelSide = {
        sideID: null,
        originalSideGuid: side.guid,
        ppcm: 0,
        imageID: null,
        code: '',
        tempImageFileKey: '',
        imageUrl: defaultModelSideImageUrl,
        areas: [],
        guid: uuid(),
        sortOrder: 0,
        mandatory: false,
        canRotate: false,
        cameraLocationID: null
    };

    return modelSide;
};

export const fitSideToImage = (side: ModelSide, image: HTMLImageElement) => {
    const area = side.areas[0];

    // Resize the area inside
    const ratio = DEFAULT_AREA_SIZE[0] / DEFAULT_AREA_SIZE[1];
    const thumbRatio = image.width / image.height;

    let width = image.width * 0.5;
    let height = width / ratio;

    if (thumbRatio > 1) {
        height = image.height * 0.5;
        width = height * ratio;
    }

    return update(side, {
        //['ppcm']: { $set: width / DEFAULT_AREA_SIZE[0] },
        ['areas']: { [0]: { $set: resizeArea(area, width, height) } }
    });
};
